import {
  dynamicTextPlaceholder,
  StaticMessage,
  StaticMessageText,
} from '@shared/enums';

export function getStaticMessage(
  messageType: StaticMessage,
  ...params: any[]
): string {
  let staticMessage = StaticMessageText.get(messageType);

  if (!params?.length || !staticMessage.includes(dynamicTextPlaceholder)) {
    return staticMessage;
  }

  params.forEach((param) => {
    staticMessage = staticMessage.replace(dynamicTextPlaceholder, param);
  });
  return staticMessage;
}
